export const MAIN_CONTENT_WIDTH = 456; // 424px + 16px horizontal padding
